<p>couch-base-detalle-usuario works!</p>
@if (usuario != null) {
  <div class="container">
    <h2>Detalles del Usuario</h2>
    <p><strong>ID:</strong> {{ usuario.usuario_id }}</p>
    <p><strong>Nombre:</strong> {{ usuario.nombre }}</p>
    <p><strong>Apellidos:</strong> {{ usuario.apellidos }}</p>
    <p><strong>Dirección:</strong> {{ usuario.direccion }}</p>
    <button class="btn btn-secondary" (click)="inc()"> inc() </button>
    <button class="btn btn-secondary" (click)="dec()"> dec() </button>
  </div>
  <input type="text" [(ngModel)]="inputProperty" placeholder="Dato del hijo" />
  <p>Hola dato del hijo, {{ inputProperty }}!</p>
  <input type="text" [(ngModel)]="inputPropertySignal" placeholder="Dato del hijo signal" />
  <p>Hola dato del hijo, {{ inputPropertySignal() }}!</p>
} @else {
  <p>No hay datos de usuario disponibles.</p>
}
